module.exports = __webpack_public_path__ + "img/transfer_out_to_right.94f40d65.png";